import type { AdminDashboard } from '@practium/features/api';
import type { DashboardConfig } from '@practium/features/dashboard';
import { BuildingIcon, FileCheckIcon, UsersIcon } from '@practium/ui';
import { getAdminCharts } from './getAdminCharts.config';

export const getAdminDashboardConfig = (data?: AdminDashboard): DashboardConfig => {
	return {
		stats: [
			{
				id: data?.cards?.[0]?.key || 'activeUsers',
				label: data?.cards?.[0]?.title || 'Usuarios Ativos',
				value: data?.cards?.[0]?.value ?? 0,
				trendValue: data?.cards?.[0]?.variationPercent ?? 0,
				trendLabel: 'vs mes anterior',
				trendDirection: (data?.cards?.[0]?.variationPercent ?? 0) >= 0 ? 'up' : 'down',
				icon: <UsersIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
			},
			{
				id: data?.cards?.[1]?.key || 'activeSubscriptions',
				label: data?.cards?.[1]?.title || 'Assinaturas Ativas',
				value: data?.cards?.[1]?.value ?? 0,
				trendValue: data?.cards?.[1]?.variationPercent ?? 0,
				trendLabel: 'este mes',
				trendDirection: (data?.cards?.[1]?.variationPercent ?? 0) >= 0 ? 'up' : 'down',
				icon: <FileCheckIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
			},
			{
				id: data?.cards?.[2]?.key || 'registeredCompanies',
				label: data?.cards?.[2]?.title || 'Empresas Registradas',
				value: data?.cards?.[2]?.value ?? 0,
				trendValue: data?.cards?.[2]?.variationPercent ?? 0,
				trendLabel: 'vs mes anterior',
				trendDirection: (data?.cards?.[2]?.variationPercent ?? 0) >= 0 ? 'up' : 'down',
				icon: <BuildingIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
			},
		],
		promotion: {
			title: 'Configure novos planos e\npermissoes',
			subtitle: 'Gerencie o acesso e funcionalidades\nda plataforma',
			buttonText: 'Ir para Operacional',
			onButtonClick: () => {
				globalThis.location.href = '/operacional';
			},
		},
		slots: getAdminCharts(data),
	};
};
